/* Activate display preparation once, near a product slot or on drawer opening.
   Hidden offer hosts have no box: observe their persistent Liquid slot instead. */
(() => {
  if (window.K9OfferActivation) return;
  window.K9OfferActivation = (offer, prepare, { signal = offer.events?.signal } = {}) => {
    let started = false, observer;
    const start = () => {
      if (started || signal?.aborted || !offer.isConnected) return;
      started = true;
      observer?.disconnect();
      prepare();
    };
    const drawer = offer.closest('cart-drawer');
    if (drawer) {
      if (drawer.classList.contains('active')) start();
      else drawer.addEventListener('k9:drawer-open', start, { once: true, signal });
    } else {
      const slot = offer.closest('[data-k9-offer-slot]') || (!offer.hidden && offer);
      if (slot && typeof IntersectionObserver !== 'undefined') {
        observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) start();
        }, { rootMargin: '400px 0px' });
        signal?.addEventListener('abort', () => observer.disconnect(), { once: true });
        observer.observe(slot);
      } else start();
    }
  };

  const scripts = new Map(), scheduled = new WeakSet(), waiting = new Map();
  function load(source) {
    if (!scripts.has(source)) {
      scripts.set(source, new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.async = true;
        script.src = source;
        script.onload = resolve;
        script.onerror = () => reject(new Error('offer-module'));
        document.head.appendChild(script);
      }));
    }
    return scripts.get(source);
  }
  // Lot 4: the anonymous offer measurement loads with the first activated card, only when its switch is on.
  function mesure() {
    const drawer = document.querySelector?.('cart-drawer');
    if (drawer?.dataset?.k9Mesure !== 'on' || !drawer.dataset.k9MesureSrc) return;
    load(drawer.dataset.k9MesureSrc).catch(() => {});
  }
  function scan(root = document) {
    for (const [offer, controller] of waiting) {
      if (!offer.isConnected) { controller.abort(); waiting.delete(offer); scheduled.delete(offer); }
    }
    for (const offer of root.querySelectorAll('[data-k9-offer-module]')) {
      if (scheduled.has(offer) || customElements.get(offer.localName)) continue;
      scheduled.add(offer);
      const controller = new AbortController();
      waiting.set(offer, controller);
      window.K9OfferActivation(offer, () => {
        waiting.delete(offer);
        mesure();
        load(offer.dataset.k9OfferModule).catch(() => { if (offer.isConnected) { offer.dataset.k9Devis = 'echec'; offer.hidden = true; } });
      }, { signal: controller.signal });
    }
  }
  window.K9OfferLoader = { scan, mesure };
  if (typeof document !== 'undefined') scan();
})();
